import * as actions from 'app/core/store/calendar/orders/calendar-orders.actions';
import * as templateActions from 'app/core/store/template/template.actions';
import { CalendarOrders } from 'app/core/store/calendar/orders/calendar-orders.interface';
import { CALENDAR_ORDERS_INITIAL_STATE } from 'app/core/store/calendar/orders/calendar-orders.model';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';

function calenderOrdersLoad(state: CalendarOrders, action: actions.CalendarOrdersLoadAction): CalendarOrders {
  return {
    ...state,
    loading: true,
    data: {
      legend: [],
      dates: [],
    },
    UI: {
      startDate: action.payload.filter.florderDateFrom,
      endDate: action.payload.filter.florderDateTo,
    },
  };
}

function findCustomer(customerId: string, isSuperUser: boolean, selectedCustomer: Customer, customers: Customer[]) {
  let customer;
  if (isSuperUser) {
    customer = isSuperUser && customers.find(c => c.id === customerId);
  } else {
    customer = selectedCustomer && selectedCustomer.id === customerId && selectedCustomer;
  }
  if (!customer) {
    throw new Error('Customer in legend not known');
  }
  return customer;
}

function calendarOrdersLoadSuccess(state: CalendarOrders, action: actions.CalendarOrdersLoadSuccessAction): CalendarOrders {
  const { dates, isSuperUser, selectedCustomer, customers } = action.payload;
  return {
    ...state,
    loaded: true,
    loading: false,
    data: {
      legend: Object.keys(dates.legend).map(customerId => {
        return {
          ...findCustomer(customerId, isSuperUser, selectedCustomer, customers),
          amount: dates.legend[customerId],
        };
      }),
      dates: dates.dates.map(x => {
        return {
          unloadingDate: x.unloadingDate,
          totalNumberOfOrders: x.totalNumberOfOrders,
          florderInfos: [
            ...x.customers.reduce((orders, customer) => {
              return [
                ...orders,
                ...customer.orders.map(order => {
                  return {
                    ...order,
                    customerId: customer.customerNumber,
                  };
                }),
              ];
            }, []),
          ],
        };
      }),
    },
  };
}

function calendarOrdersLoadFail(state: CalendarOrders, action: actions.CalendarOrdersLoadFailAction): CalendarOrders {
  return {
    ...state,
    loaded: false,
    loading: false,
    items: [],
    filteredItems: [],
    totalItems: null,
  };
}

function calendarOrdersTemplateSelected(state: CalendarOrders, action: actions.CalendarOrdersTemplateSelectedAction): CalendarOrders {
  return {
    ...state,
    selectedTemplate: state.selectedTemplate === action.payload ? null : action.payload,
    availableDays: state.selectedTemplate === action.payload || !action.payload ? null : state.availableDays,
  };
}

function calendarOrdersRequestOrderDeliveryDates(state: CalendarOrders, action: actions.CalendarOrdersRequestOrderDeliveryDatesAction): CalendarOrders {
  return {
    ...state,
    deliveryDaysRequesting: true,
    deliveryDaysRequested: false,
    availableDays: null,
  };
}

function calendarOrdersRequestOrderDeliveryDatesSuccess(state: CalendarOrders, action: actions.CalendarOrdersRequestOrderDeliveryDatesSuccessAction): CalendarOrders {
  return {
    ...state,
    deliveryDaysRequesting: false,
    deliveryDaysRequested: true,
    availableDays: action.payload,
  };
}

function calendarOrdersRequestOrderDeliveryDatesFail(state: CalendarOrders, action: actions.CalendarOrdersRequestOrderDeliveryDatesFailAction): CalendarOrders {
  return {
    ...state,
    deliveryDaysRequesting: false,
    deliveryDaysRequested: false,
    availableDays: null,
    selectedTemplate: null,
  };
}

function calendarOrdersClearState(state: CalendarOrders, action: actions.CalendarOrdersClearStateAction): CalendarOrders {
  return CALENDAR_ORDERS_INITIAL_STATE;
}

function calendarEmptyDates(state: CalendarOrders, action: actions.CalendarEmptyDatesAction): CalendarOrders {
  return {
    ...state,
    data: {
      legend: [],
      dates: [],
    },
  };
}

function calendarOrderDeliveryDatesReset(state: CalendarOrders, action: actions.CalendarOrdersDeliveryDatesReset) {
  return {
    ...state,
    deliveryDaysRequesting: false,
    deliveryDaysRequested: false,
    availableDays: null,
    selectedTemplate: null,
  };
}

function templateDeleteSuccess(state: CalendarOrders, action: templateActions.TemplatesDeleteSuccessAction): CalendarOrders {
  return {
    ...state,
    selectedTemplate: state.selectedTemplate?.id === action.payload.id ? null : state.selectedTemplate,
    availableDays: state.selectedTemplate?.id === action.payload.id ? null : state.availableDays,
  };
}

export function reducer(state = CALENDAR_ORDERS_INITIAL_STATE, action: actions.Actions | templateActions.Actions): CalendarOrders {
  let newState: CalendarOrders = state;

  switch (action.type) {
    case actions.CALENDAR_EMPTY_DATES:
      newState = calendarEmptyDates(state, action);
      break;
    case actions.CALENDAR_ORDERS_LOAD:
      newState = calenderOrdersLoad(state, action);
      break;
    case actions.CALENDAR_ORDERS_LOAD_SUCCESS:
      newState = calendarOrdersLoadSuccess(state, action);
      break;
    case actions.CALENDAR_ORDERS_LOAD_FAIL:
      newState = calendarOrdersLoadFail(state, action);
      break;
    case actions.CALENDAR_ORDERS_TEMPLATE_SELECTED:
      newState = calendarOrdersTemplateSelected(state, action);
      break;
    case actions.CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES:
      newState = calendarOrdersRequestOrderDeliveryDates(state, action);
      break;
    case actions.CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_SUCCESS:
      newState = calendarOrdersRequestOrderDeliveryDatesSuccess(state, action);
      break;
    case actions.CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_FAIL:
      newState = calendarOrdersRequestOrderDeliveryDatesFail(state, action);
      break;
    case actions.CALENDAR_ORDERS_CLEAR_STATE:
      newState = calendarOrdersClearState(state, action);
      break;
    case actions.CALENDAR_ORDERS_REQUEST_ORDER_DELIVERY_DATES_RESET:
      newState = calendarOrderDeliveryDatesReset(state, action);
      break;
    case templateActions.TEMPLATES_DELETE_SUCCESS:
      newState = templateDeleteSuccess(state, action);
      break;
  }

  return newState;
}
